import { useQuery } from '@tanstack/react-query';
import { clientGetFile, clientGetFilesForHousehold, useGraphqlClient } from '../graphql';
import { fileQueryKeys } from './queryKeys';

interface UseFileOptions {
  enabled?: boolean;
}

export const useFile = (
  tenantID: string | undefined | null,
  id: string | undefined | null,
  { enabled = true }: UseFileOptions = {}
) => {
  const gqlClient = useGraphqlClient();
  const fileQuery = useQuery({
    enabled: enabled && !!tenantID && !!id,
    queryKey: fileQueryKeys.file(tenantID, id),
    queryFn: () => {
      if (!tenantID || !id) throw new Error('Tenant ID and file ID are required to load a file.');
      return clientGetFile(gqlClient, { tenantID, id });
    },
  });

  return {
    file: fileQuery.data,
    fileQuery,
  };
};

export const useFilesForHousehold = (householdID: string | undefined | null) => {
  const gqlClient = useGraphqlClient();
  const filesForHouseholdQuery = useQuery({
    enabled: !!householdID,
    queryKey: fileQueryKeys.filesForHousehold(householdID),
    queryFn: () => {
      if (!householdID) throw new Error('Household ID is required to load files.');
      return clientGetFilesForHousehold(gqlClient, { householdID });
    },
  });

  return {
    files: filesForHouseholdQuery.data?.items ?? [],
    filesForHouseholdQuery,
  };
};
